import { Promotion, PromotionOffer, PromotionOfferType } from '@lib/types';

export interface PromotionOfferDTO {
  id: string;
  type: PromotionOfferType;
  name: string;
  gameCode: string;
  availableQuantity: number;
  imageUrl?: string;
  cardSlug?: string;
  printingCode?: string;
  collectionName?: string;
  rarityName?: string;
  languageCode?: string;
  condition?: string;
  originalPriceCents: number;
  discountCents: number;
  effectivePriceCents: number;
}

export interface PromotionDTO {
  id: string;
  name: string;
  revision?: number;
  discountType: 'percentage' | 'fixed_amount';
  discountValue: number;
  startsAt: string;
  endsAt: string;
  endedAt: string | null;
  archivedAt?: string | null;
  offers: PromotionOfferDTO[];
}

export interface PromotionOfferPageDTO {
  items: PromotionOfferDTO[];
  total: number;
}

export const createPromotionOffer = (
  dto: PromotionOfferDTO,
): PromotionOffer => ({
  id: dto.id,
  type: dto.type,
  name: dto.name,
  gameCode: dto.gameCode,
  availableQuantity: dto.availableQuantity,
  imageUrl: dto.imageUrl,
  cardSlug: dto.cardSlug,
  printingCode: dto.printingCode,
  collectionName: dto.collectionName,
  rarityName: dto.rarityName,
  languageCode: dto.languageCode,
  condition: dto.condition,
  originalPriceCents: dto.originalPriceCents,
  discountCents: dto.discountCents,
  effectivePriceCents: dto.effectivePriceCents,
});

export const createPromotion = (dto: PromotionDTO): Promotion => ({
  id: dto.id,
  name: dto.name,
  revision: dto.revision,
  discountType: dto.discountType,
  discountValue: dto.discountValue,
  startsAt: dto.startsAt,
  endsAt: dto.endsAt,
  endedAt: dto.endedAt,
  archivedAt: dto.archivedAt,
  offers: dto.offers.map(createPromotionOffer),
});
